import { NavigateFunction } from 'react-router-dom';

export const navigateToSession = (
  navigate: NavigateFunction,
  siteSlug: string,
  sessionId: string,
  withAudio: boolean,
  withVideo: boolean,
) => {
  const url = `/${siteSlug}/sessions/${sessionId}?withAudio=${withAudio}&withVideo=${withVideo}`;
  navigate(url);
};

export const openSessionInNewTab = (
  siteSlug: string,
  sessionId: string,
  withAudio: boolean,
  withVideo: boolean,
) => {
  const url = `/${siteSlug}/sessions/${sessionId}?withAudio=${withAudio}&withVideo=${withVideo}`;
  window.open(url, '_blank');
};
